// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_41z","cls2":"search_work_card_redesign-cls2_D_S search_work_card_redesign-cls1_41z"};